import jump from 'jump.js'

const getStuckHeight = () => {
  const $header = document.querySelector('.site-header')

  let offset = 0

  if ($header) {
    offset = 90

    if (window.matchMedia('(min-width: 768px)').matches) {
      offset = 105
    }

    if (window.matchMedia('(min-width: 1024px)').matches) {
      offset = 125
    }
  }

  return offset
}

const scrollTo = ($target, additionalOffset = 0) => {
  const headerOffset = getStuckHeight() * -1
  let offset = headerOffset - additionalOffset

  if ($target.classList.contains('section-pledge')) {
    offset -= 64
  }

  return new Promise((resolve) => {
    jump($target, { duration: 500, offset, callback: resolve })
  })
}

export default scrollTo
